var VouchersPromoView = (function(BaseView) {

    return BaseView.extend({
        el: '@discount',

        displayRoutes: ['checkout.vouchers'],

        initialize: function() {
            new PromoCodeView({ model: this.model.get('PromoCode') });
            new VouchersListView({ collection: this.model.get('Vouchers') });
            new PromocodesListView({ collection: this.model.get('Promocodes'), model: this.model.get('PromoCode') });
        }
    });

})(BaseView)